import type { Bookmark } from '@/types/Bookmark'

import ky from './httpService'

export const getBookmarks = async ({ search = '' }): Promise<Array<Bookmark>> => {
  const URI = `api/bookmark/`

  const searchParams = new URLSearchParams()
  searchParams.append('search', String(search))

  return await ky.get(URI, { searchParams }).json()
}

export const saveBookmark = async (bookmark: Bookmark): Promise<Bookmark> => {
  const URI = 'api/bookmark/'

  return await ky.post(URI, { json: bookmark }).json()
}

export const removeBookmark = async (idBookmark: string) => {
  const URI = 'api/bookmark/' + encodeURIComponent(idBookmark)

  return await ky.delete(URI).json()
}
